import { ILocationConfiguration } from 'api/interfaces/location';
import { LocationServiceAPI } from 'api/services/locationServiceAPI';
import { makeAutoObservable } from 'mobx';

class LocationStore {
	selectedLocation: ILocationConfiguration | undefined = undefined;
	locationsCount: number = 0;

	constructor() {
		makeAutoObservable(this);
	}

	setLocationsCount = (count: number) => {
		this.locationsCount = count;
	};

	setSelectedLocation = (location: ILocationConfiguration | undefined) => {
		this.selectedLocation = location;
	};

	selectLocation = async (locationId: string) => {
		if (this.selectedLocation?.id === locationId) return;

		const location = await this.fetchLocationDetails(locationId);
		this.setSelectedLocation(location);
	};

	private fetchLocationDetails = async (locationId: string) => {
		try {
			const location = await LocationServiceAPI.getLocationDetails(locationId);

			return location.data;
		} catch (error) {
			console.error('Error fetching location details:', error);
		}
	};
}

export const locationStore = new LocationStore();
